<template>
  <div class="video">
    <video
      controls="true"
      autoplay="true"
      src="static/readme.m4v"></video>
  </div>
</template>

<script>
  export default {
    name: "pcVideo"
  }
</script>

<style scoped lang="less">
.video{
position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  video{
    width:100%;
    height:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pcVideo.vue